<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    @click:outside="cancel"
    class="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>{{ type === 'update' ? 'SỬA' : 'THÊM' }} CÂU LẠC BỘ</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-form ref="form" flat class="pa-3">
        <v-col cols="12" md="12" class="pb-0">
          <v-text-field
            v-model="name"
            label="Tên câu lạc bộ"
            outlined
            required
            dense
            class="required"
            :rules="[$rules.required]"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="pb-0">
          <v-text-field
            v-model="maxMembers"
            label="Số lượng thành viên tối đa"
            outlined
            required
            type="number"
            dense
            class="required"
            :rules="[$rules.required]"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="pb-0">
          <v-textarea v-model="description" label="Mô tả" outlined required dense> </v-textarea>
        </v-col>
      </v-form>
      <v-divider />
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
        <v-btn depressed class="px-6 mr-2 white--text" color="primary " @click="save">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      id: '',
      type: '',
      name: '',
      description: '',
      maxMembers: null
    }
  },
  methods: {
    ...mapActions({ fetchOne: 'club/fetchOne', create: 'club/create', update: 'club/update' }),
    ...mapMutations({ setState: 'club/setState' }),
    openDialog(type, item) {
      if (type === 'update') {
        this.id = item.id
        this.name = item.name
        this.description = item.description
        this.maxMembers = item.maxMembers
      }
      this.type = type
      this.dialog = true
    },
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.name = ''
      this.maxMembers = 0
    },
    async save() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          const data = {
            name: this.name,
            maxMembers: this.maxMembers
          }
          if (this.description) data.description = this.description

          if (this.type === 'update') {
            await this.update({ id: this.id, ...data })
            await this.fetchOne(this.id)
            this.$alert.success('Chỉnh sửa thành công')
          } else {
            const item = await this.create(data)
            this.$router.push(`/club-detail/${item.id}`)
          }
          this.cancel()
        } catch (error) {
          this.$alert.error(error)
        } finally {
          this.$loading.active = false
        }
      }
    }
  }
}
</script>
